import { z } from 'zod';
export const CreateDocumentSchema = z.object({
    id: z.number()
});
//# sourceMappingURL=createDocumentSchema.js.map